export {
  FLAG,
  parseImpl,
  IResult,
  getEmptyResult,
  resetResult,
} from './src/factory';
export { IPublicSuffix, ISuffixLookupOptions } from './src/lookup/interface';
export { default as fastPathLookup } from './src/lookup/fast-path';
export { IOptions, setDefaults } from './src/options';
